var $ = require('jquery');
var Router = require('./router');

Router.config({ mode: 'history'});

module.exports = (function() {
    var $routerElement = $('.router');

    if($routerElement.length == 0) return;

    Router
    .add(/(catalog\/(.*))/, function(url) {
        url = Router.root + url;

        url = url.replace(/(\?|\&)isNaked=1/i, '');

        $routerElement.addClass('router--loading');

        var prom = $.ajax({
			url: url + (url.indexOf('?') === -1 ? '?' : '&') + 'isNaked=1',
			type: 'get',
			dataType: 'html'
		}).done(function() {
            $(window).trigger('resize');
            $('html, body').animate({ scrollTop: $routerElement.offset().top }, 'slow');
        });

        setTimeout(function() {
            prom.done(function(data) {
                var $data = $(data);

                $routerElement.find('.router__content').html($data.find('.router__content').html());
                $routerElement.find('.router__nav').html($data.find('.router__nav').html());

                $routerElement.removeClass('router--loading');
            });
        }, 500);

    })
    .listen();

    var $form = $('.sidebar__form');

    $form.find(':checkbox').on('change', function() {
        var url = window.location.pathname + '?' + $(this).closest($form).serialize();

        Router.navigate(url).check(url);
    });

    $form.find('input[type="number"]').on('change', function() {
        var url = window.location.pathname + '?' + $(this).closest($form).serialize();

        Router.navigate(url).check(url);
    });

    $routerElement.on('click', '.router__nav a', function(e) {
        e.preventDefault();
        e.stopPropagation();

        this.search = this.search.replace(/(\?|\&)isNaked=1/i, '');

        Router.navigate(this.pathname + this.search).check(this.pathname + this.search);
    });
})();
